import React, { use, useEffect, useState } from "react";
import {
  abhaCartDownloadServices,
  abhaCartDownloadServicesVerification,
  CreateAbhaUserServices,
  UpdateAbhaUserServices
} from "../../services";
import "./abhacard.css";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setGlobalCurrentStep } from "../../redux/slices/abhaSlice";

const AbhaCardUI = ({ downloadFlowToken, inputType }) => {
  const [abhacarddata, setAbhacarddata] = useState("");
  const [xToken, setXToken] = useState(null);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [showFull, setShowFull] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  let userInfo;
  if (userData?.accounts?.length > 0) {
    userInfo = userData?.accounts[0];
  } else if (userData?.users?.length > 0) {
    userInfo = userData?.users;
  } else {
    userInfo = userData;
  }
  console.log("+***", userData);
  console.log("====", userInfo);
  const downloadabha = async () => {
    try {
      const storedToken = localStorage.getItem("downloadToken");
      console.log("storedToken", storedToken);
      const finalToken = storedToken;

      if (!finalToken) {
        console.error("No xToken available!");
        return;
      }

      setXToken(finalToken);

      const body = {
        xToken: finalToken
      };

      const response =
        downloadFlowToken === true
          ? await abhaCartDownloadServices({ body })
          : await abhaCartDownloadServicesVerification({ body });
      console.log("response---------", response);

      if (response.status) {
        console.log(typeof response, "+++++++++++++===s");

        setAbhacarddata(response.result);
        const patientData = JSON.parse(localStorage.getItem("selectedIndex"));
        console.log("patientData", patientData);

        const dob = new Date(userInfo?.dob);
        const yyyy = dob.getFullYear();
        const mm = String(dob.getMonth() + 1).padStart(2, "0");
        const dd = String(dob.getDate()).padStart(2, "0");
        const formattedDob = `${yyyy}-${mm}-${dd}`;

        const updateBody = {
          patientId: patientData?._id,
          abhaAddress: userInfo?.abhaAddress || userInfo?.preferredAbhaAddress,
          healthIdNumber: userInfo?.abhaNumber || userInfo?.ABHANumber,
          abhaDOB: userInfo?.dob
            ? formattedDob
            : userInfo?.age
              ? userInfo?.age
              : "" || userInfo?.abhaDOB,
          abhaGender: userInfo?.gender,
          abhaName: userInfo?.firstName
            ? userInfo?.firstName +
              " " +
              userInfo?.middleName +
              " " +
              userInfo?.lastName
            : userInfo?.fullName
              ? userInfo?.fullName
              : "" || userInfo?.name
          // abhaCard: base64Data,
        };
        // const responsed = await UpdateAbhaUserServices({ body: updateBody });
        let responsed;
        if (patientData && patientData?._id) {
          responsed = await UpdateAbhaUserServices({body: updateBody});
        } else {
          delete updateBody["patientId"];
          responsed = await CreateAbhaUserServices({body: updateBody});
        }
        if (responsed.status) {
          console.log("ABHA user updated successfully");
        }
      } else {
        console.error("No card data in response", response);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };

  const handleDownload = (e) => {
    e.preventDefault();
    if (!abhacarddata) {
      toast.error("No card data available to download.");
      return;
    }
    const link = document.createElement("a");
    link.href = `data:image/png;base64,${abhacarddata}`;
    link.download = "abha-card.png";
    link.click();
    window.location.reload();
  };

  useEffect(() => {
    if (abhacarddata) {
      const imgUrl = `data:image/png;base64,${abhacarddata}`;
      setImageUrl(imgUrl);
      setLoading(false);
    }
  }, [abhacarddata]);

  useEffect(() => {
    downloadabha();
  }, []);
  return (
    <div className="col-12">
      <div className="form-card content">
        <h3>ABHA created successfully!</h3>
        <form className="pt-3">
          <div className="col-lg-12">
            <div className="p-3 text-center">
              {loading ? (
                <div className="shimmer-card"></div>
              ) : (
                <img
                  src={imageUrl}
                  className="abha-card-download"
                  alt="ABHA Card"
                  onClick={() => setShowFull(true)}
                />
              )}
            </div>
          </div>
          <button className="continue-btn" onClick={handleDownload}>
            DOWNLOAD YOUR ABHA CARD NOW
          </button>
          {inputType !== "abhaaddress" && (
            <>
              <h3 style={{ textAlign: "center", marginTop: 10 }}>OR</h3>
              <button
                className="continue-btn mt-2"
                onClick={() => dispatch(setGlobalCurrentStep("changeMobile"))}
              >
                Change Contact
              </button>
            </>
          )}
        </form>

        {showFull && (
          <div className="image-modal">
            <span className="close-btn2" onClick={() => setShowFull(false)}>
              &times;
            </span>
            <img
              src={imageUrl}
              className="modal-content"
              alt="ABHA Card Full"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AbhaCardUI;
